import React from 'react';

/** Nicely-styled download link (icon + label) for documentation files. */
const DownloadButton: React.FC<{ href: string; label?: string; style?: React.CSSProperties }> = ({
  href,
  label = 'Pobierz',
  style,
}) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="btn btn-primary"
    style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '0.45rem', textDecoration: 'none', ...style }}
  >
    <svg
      width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
    {label}
  </a>
);

export default DownloadButton;
